export default "__VITE_ASSET__DY_pJ$84__"